<template>
    <div class="zhuli-page">
      <div class="zhuli-container">
        <div class="zhuli-content">
          <div class="avatar-wrapper">
            <img 
              :src="userInfo.avatar" 
              :alt="userInfo.name" 
              class="avatar" 
              @error="handleAvatarError"
            />
          </div>
          <p class="name">{{ userInfo.name }}</p>
        </div>
        
          <div class="click-area">
            <hitv-call-app :scheme-url="callPlayerUrl" class="call-app">
            </hitv-call-app>
          </div>
        
        <div class="activity-info">
          <div class="title">活动说明</div>
          <div class="content">
            1、用户可以邀请好友签到助力获得额外红包，每成功邀请1个好友签到，可额外获得1个红包，每天邀请好友的数量有限，具体以页面展示为准。<br>
            2、用户邀请的好友必须为APP新用户(手机设备、账号均未登录使用过本APP)，且邀请方、被邀请方及其邀请参与等行为均不存在本《活动规则》所述不予通过提现的，才视为邀请成功可获得奖励。<br>
            3、关于平台新用户的定义：被邀请人首次使用新的移动设备下载芒果TV APP，并注册芒果TV新账号，登录使用芒果TV APP。如不满足，则不视为新用户。
          </div>
        </div>
      </div>
      <div class="bg-container">
        <div class="bg-image"></div>
      </div>
    </div>
</template>

<script>
import { callApp, setNewWXShareInfo } from '@/utils/mUtil'
import { getInfoByInviteCode } from '@/request/cash';

export default {
  name: 'ZhuliPage',
  data() {
    return {
      userInfo: {
        avatar: '',
        name: '',
      },
      inviteCode: '',
      defaultAvatar: require('@/assets/v2/portrait_offline.png'),
    }
  },
  computed: {
    callPlayerUrl() {
      const url =
        location.origin + location.pathname + '#/?inviteCode=' + this.inviteCode
      return `imgotv://webview?url=${encodeURIComponent(url)}`
    },
  },
  created() {
    const { inviteCode } = this.$route.query
    this.inviteCode = inviteCode
    this.setWxShare()
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      try {
        const { code, data } = await getInfoByInviteCode({ inviteCode: this.inviteCode });

        if (code === 200) {
          this.userInfo = {
            avatar: data.photo,
            name: data.nickname,
          };
        }
      } catch (error) {
        console.error('获取用户信息失败：', error);
      }
    },
    setWxShare() {
      const shareInfo = {
        title: '奖励中心领现金秒到账！',
        shareUrl: location.href,
        desc: '每天开幸运盲盒，最高可得10元现金奖励！',
        shareIcon:
          'https://ossimg.hitv.com/platform_oss/0A666DA9702845268AD8C0FAF59ABB4A.png',
      };
      setNewWXShareInfo(shareInfo);
    },
    handleAvatarError(e) {
      e.target.src = this.defaultAvatar;
    },
  },
}
</script>

<style lang="less" scoped>
.zhuli-page {
  min-height: 100vh;
  height: 100%;
  position: relative;
  background: rgba(255, 212, 155);

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(255, 212, 155);
    z-index: 0;

    @media screen and (min-width: 600px) {
      left: 50%;
      width: 750px;
      transform: translateX(-50%);
    }
  }

  .bg-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-bottom: 177.78%; /* 根据背景图实际宽高比调整 */
    z-index: 1;

    .bg-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('../../../assets/v2/zhuli-1.png') no-repeat center top;
      background-size: cover;
    }
  }

  .zhuli-container {
    position: relative;
    z-index: 2;
    width: 100%;
    min-height: 100vh;

    .zhuli-content {
      position: absolute;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      top: calc(47.33 * var(--vw-base)); /* 355/750*100 */

      .avatar-wrapper {
        width: calc(15.47 * var(--vw-base)); /* 116/750*100 */
        height: calc(15.47 * var(--vw-base)); /* 116/750*100 */
        padding: calc(0.8 * var(--vw-base)); /* 6/750*100 */
        background: linear-gradient(
          158deg,
          rgba(253, 176, 62, 1),
          rgba(255, 225, 181, 1),
          rgba(225, 134, 0, 1)
        );
        border-radius: 50%;

        .avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      .name {
        font-family: PingFang SC-Medium;
        max-width: 300px;
        overflow: hidden;
        word-break: keep-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: calc(2.4 * var(--vw-base)); /* 18/750*100 */
        font-weight: 500;
        font-size: calc(3.2 * var(--vw-base)); /* 24/750*100 */
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .click-area {
      position: absolute;
      width: 100%;
      height: 429px;
      top: calc(69.33 * var(--vw-base)); /* 520/750*100 */
      .call-app {
        width: 100%;
        height: 100%;
      }
    }
    .activity-info {
      position: absolute;
      width: calc(100% - 100px);
      left: 50px;
      top: calc(151.07 * var(--vw-base)); /* 1133/750*100 */
      padding: calc(4.8 * var(--vw-base)) calc(6.67 * var(--vw-base)); /* 36/750*100 50/750*100 */
      background: rgba(0, 0, 0, 0.08);
      border-radius: calc(4.8 * var(--vw-base)); /* 36/750*100 */

      .title {
        font-weight: 500;
        font-size: calc(3.73 * var(--vw-base)); /* 28/750*100 */
        color: #fff;
        text-align: center;
      }
      .content {
        max-height: calc(17.06 * var(--vw-base)); /* 128/750*100 */;
        overflow-y: scroll;
        margin-top: calc(1.6 * var(--vw-base)); /* 12/750*100 */
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        font-size: calc(2.93 * var(--vw-base)); /* 22/750*100 */
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
</style>
